import { useNavigate, useLocation } from 'react-router-dom';
import { House, PlusCircle, User, ListChecks, SignOut } from '@phosphor-icons/react';

import { ThemeToggle } from '@/components/ui';
import { UserAvatar } from '@/components/features/UserAvatar/UserAvatar';
import { useAuthStore } from '@/stores';
import { ROUTES, PROJECT_NAME } from '@/constants';

import styles from './Sidebar.module.css';

export function Sidebar() {
    const navigate = useNavigate();
    const location = useLocation();
    const { isLogged, getUser, logOut } = useAuthStore();
    const user = getUser();

    const navItems = [
        { icon: <House size={20} />, label: 'Inicio', path: ROUTES.feed },
        ...(isLogged
            ? [
                { icon: <PlusCircle size={20} />, label: 'Crear', path: ROUTES.create },
                { icon: <ListChecks size={20} />, label: 'Mis encuestas', path: ROUTES.myPolls },
                { icon: <User size={20} />, label: 'Perfil', path: user ? `/${user.slug}` : '#' },
            ]
            : []),
    ];

    const handleLogout = async () => {
        await logOut();
        navigate(ROUTES.login);
    };

    return (
        <aside className={styles.sidebar}>
            <button className={styles.logo} onClick={() => navigate(ROUTES.feed)} aria-label="Ir al inicio">
                <img src="/logo.svg" alt={PROJECT_NAME} className={styles.logoImg} />
                <span className={styles.logoText}>{PROJECT_NAME}</span>
            </button>

            <nav className={styles.nav}>
                {navItems.map((item) => (
                    <button
                        key={item.path}
                        className={`${styles.navItem} ${location.pathname === item.path ? styles.active : ''}`}
                        onClick={() => navigate(item.path)}
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </button>
                ))}
            </nav>

            <div className={styles.footer}>
                <ThemeToggle />
                {isLogged && user && (
                    <div className={styles.userSection}>
                        <UserAvatar
                            src={user.avatar_url}
                            name={user.display_name}
                            size="sm"
                        />
                        <span className={styles.userName}>{user.display_name}</span>
                        <button
                            className={styles.logoutBtn}
                            onClick={handleLogout}
                            aria-label="Cerrar sesion"
                        >
                            <SignOut size={16} />
                        </button>
                    </div>
                )}
            </div>
        </aside>
    );
}
